import React from "react";
import { useTranslation } from 'react-i18next';

import {
  Box,
  Button,
  Divider,
  Grid,
  Menu,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Switch,
} from "@mui/material";

import {
  RadioButtonChecked as RadioButtonCheckedIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
} from "@mui/icons-material";

const LOADING_CONTAINER_COLOR = "loading_color";
const UNLOADING_CONTAINER_COLOR = "unloading_color";

export interface PlannerViewSettingProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  width?: number | string;
}

const PlannerViewSettings: React.FC<PlannerViewSettingProps> = ({
  anchorEl,
  open,
  onClose,
  containerColorType,
  setContainerColorType,
  positionModeEnabled,
  setPositionModeEnabled,
  shiftingModeEnabled,
  setShiftingModeEnabled,
  containerGridLabelSwitch,
  setContainerGridLabelSwitch,
  width = 450,
}) => {
  const { t } = useTranslation();

  const handleClear = () => {
    setContainerColorType(UNLOADING_CONTAINER_COLOR);
    setPositionModeEnabled(false)
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width, p: 1 } }}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
    >
      <Box display="flex" flexWrap="wrap" gap={2}>
        <Box width="calc(50% - 8px)">
            <Grid item display="flex" flexWrap="nowrap" alignItems="flex-start" justifyContent="flex-start" flexDirection="column" gap={1}>
              <Grid container flexWrap="nowrap">
                <Switch
                    size="small"
                    checked={positionModeEnabled}
                    onChange={e => setPositionModeEnabled(e.target.checked)}
                    inputProps={{ "aria-label": "toggle position mode" }}
                />
                <Typography
                    variant="body2"
                    color={positionModeEnabled ? "success.main" : "text.secondary"}
                >
                    {t("clickToPosition")}
                </Typography>
              </Grid>
              <Grid container flexWrap="nowrap">
                <Switch
                    size="small"
                    checked={shiftingModeEnabled}
                    onChange={e => setShiftingModeEnabled(e.target.checked)}
                    inputProps={{ "aria-label": "toggle position mode" }}
                />
                <Typography
                    variant="body2"
                    color={shiftingModeEnabled ? "success.main" : "text.secondary"}
                >
                    {t("allowShifting")}
                </Typography>
              </Grid>
              <Grid container flexWrap="nowrap">
                <Switch
                    size="small"
                    checked={containerGridLabelSwitch}
                    onChange={e => setContainerGridLabelSwitch(e.target.checked)}
                    inputProps={{ "aria-label": "toggle position mode" }}
                />
                <Typography
                    variant="body2"
                    color={containerGridLabelSwitch ? "success.main" : "text.secondary"}
                >
                    {t("containerGridLabel")}
                </Typography>
              </Grid>
            </Grid>
        </Box>
        <Box width="calc(50% - 8px)">
            <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                {t("planColor")}
            </Typography>
            <Divider />
            <List dense disablePadding>
                <ListItem button onClick={(e: any) => setContainerColorType(LOADING_CONTAINER_COLOR)} sx={{
                    paddingLeft: "0 !important",
                }}>
                    <ListItemIcon sx={{ minWidth: 32 }}>
                    {   containerColorType &&
                        containerColorType === LOADING_CONTAINER_COLOR ? (
                        <RadioButtonCheckedIcon color="primary" fontSize="small" />
                    ) : (
                        <RadioButtonUncheckedIcon
                        color="primary"
                        fontSize="small"
                        />
                    )}
                    </ListItemIcon>
                    <ListItemText
                    primary={t("loadingColor")}
                    primaryTypographyProps={{ noWrap: true }}
                    />
                </ListItem>
                <ListItem button onClick={(e: any) => setContainerColorType(UNLOADING_CONTAINER_COLOR)} sx={{
                    paddingLeft: "0 !important",
                }}>
                    <ListItemIcon sx={{ minWidth: 32 }}>
                    {   containerColorType &&
                        containerColorType === UNLOADING_CONTAINER_COLOR ? (
                        <RadioButtonCheckedIcon color="primary" fontSize="small" />
                    ) : (
                        <RadioButtonUncheckedIcon
                        color="primary"
                        fontSize="small"
                        />
                    )}
                    </ListItemIcon>
                    <ListItemText
                    primary={t("unloadingColor")}
                    primaryTypographyProps={{ noWrap: true }}
                    />
                </ListItem>
            </List>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        mt={1}
        borderTop="1px solid #DDD"
        pt={1}
      >
        <Button size="small" onClick={handleClear}>
          {t("clear")}
        </Button>
        <Button size="small" onClick={onClose}>
          {t("close")}
        </Button>
      </Box>
    </Menu>
  );
};

export default PlannerViewSettings;